import api from './api';

export const getQuestions = () =>
  api.get('/quarterly-checkin/questions').then(r => r.data.sectors);

export const getLatestCheckin = () =>
  api.get('/quarterly-checkin/latest').then(r => r.data.checkin);

export const submitCheckin = (answers) =>
  api.post('/quarterly-checkin', { answers }).then(r => r.data.checkin);
